METAPHYSICS